import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

//Componentes
//import Login from './components/admin/Login.vue';

const page="./components/page/";

const MyRouter = new VueRouter({
  	routes:[
	    { path: '/', name: 'homePage', component: require(page+'home.vue').default, meta:{title:"Home"}},
	    { path: '/precios', component: require(page+'pricing/index.vue').default, meta:{title:"Precios"}},
	    { path: '/precios/checkout', component: require(page+'pricing/payment.vue').default, meta:{title:"Checkout"}},
	    { path: '/nosotros', component: require(page+'about-us/index.vue').default, meta:{title:"Nosotros"}},
	    { path: '/contacto', component: require(page+'contact/index.vue').default, meta:{title:"Contacto"}},
	    { path: '/faqs', component: require(page+'faqs/index.vue').default, meta:{title:"Preguntas frecuentes"}},
	    { path: '/afiliacion', component: require(page+'im-lawyer/index.vue').default, meta:{title:"Soy abogado"}},
	    { path: '/afiliacion/solicitud', component: require(page+'afiliation/index.vue').default, meta:{title:"Solicitud de afiliación"}},
	    { path: '/como-funciona', component: require(page+'how-works/index.vue').default, meta:{title:"Cómo funciona"}},
	    { path: '/directorio', component: require(page+'directory/index.vue').default, meta:{title:"Directorio de abogados"}},
	    { path: '/directorio/:id', component: require(page+'directory/detail.vue').default, meta:{title:"Perfil profesional"}},
	    { path: '/chat', component: require(page+'lexi-chat/index.vue').default, meta:{title:"Consulta con Lexi"}},

			{ path: '/aviso-de-privacidad', component: require(page+'text-pages/aviso.vue').default, meta:{title:"Aviso de privacidad"}},
	    { path: '/terminos-y-condiciones', component: require(page+'text-pages/terminos.vue').default, meta:{title:"Términos y condiciones"}},

			{ path: '/login', component: require(page+'user-access/login.vue').default, meta:{title:"Iniciar sesión"}},
	    {
				path: '/mi-cuenta',
				component: require(page+'user-account/index.vue').default,
				meta:{title:"Mi cuenta"},
				redirect: '/mi-cuenta/perfil',
				children: [
					{ path: 'perfil', component: require(page+'user-account/my-data.vue').default, meta:{title:"Edición de Perfil"}},
					{ path: 'expediente', component: require(page+'user-account/expediente.vue').default, meta:{title:"Mi Expediente"}},
					{ path: 'favoritos', component: require(page+'user-account/favoritos.vue').default, meta:{title:"Mis favoritos"}},
					{ path: 'plan', component: require(page+'user-account/plan.vue').default, meta:{title:"Mi Plan"}},
					{ path: 'lexi', component: require(page+'user-account/lexi.vue').default, meta:{title:"Lexi"}},
				],
			},

		// { path: '/operations/:id', component: require(page+'operations/shipping-guide.vue').default, meta:{title:"Guía de Envío"}},
	 ]
});

MyRouter.beforeEach((to, from, next) => {
	window.scrollTo(0,0);
	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		window.app.__vue__.$refs.loadingBar.start();
	}
	next();
});

MyRouter.afterEach((to, from) => {	

	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		setTimeout(()=>{
			window.app.__vue__.$refs.loadingBar.done();
		},500);
	}

	
});

//Titulos del website
import VueDocumentTitlePlugin from "vue-document-title-plugin";
Vue.use(VueDocumentTitlePlugin, MyRouter, 
	{ defTitle: "Unlawk", filter: (title)=>{ return title+" - Unlawk"; } }
);
	  
// export {routes};
export default MyRouter;